import Ordinance from './Ordinance'

export default class EndowmentOrdinance extends Ordinance {
  constructor(endowment, t) {
    super({
      data: endowment,
      title: t('wcf.person-ordinances.endowment', 'Endowment'),
      t,
    })
  }
}
